import cx from 'classnames';
import Axis from "./Axis.js";
import Orientation from "../constants/orientation.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const topTickLabelProps = {
  dy: '-0.75em',
  fill: '#222',
  fontFamily: 'Arial',
  fontSize: 10,
  textAnchor: 'middle'
};
export default function AxisTop(_ref) {
  let {
    axisClassName,
    labelOffset = 8,
    tickLength = 8,
    tickLabelProps,
    ...restProps
  } = _ref;
  const tickLabelPropsFinal = typeof tickLabelProps === 'function' ? tickLabelProps : {
    ...topTickLabelProps,
    ...tickLabelProps
  };
  return /*#__PURE__*/_jsx(Axis, {
    axisClassName: cx('visx-axis-top', axisClassName),
    labelOffset: labelOffset,
    orientation: Orientation.top,
    tickLabelProps: tickLabelPropsFinal,
    tickLength: tickLength,
    ...restProps
  });
}